import React, { useEffect } from "react";
import moment from "moment";
import { GeneralTable } from "../GeneralComponents/GeneralTable";
import AssignmentIcon from "@material-ui/icons/Assignment";
import history from "../../history";
import CloudUploadIcon from "@material-ui/icons/CloudUpload";
import { useModalAlert } from "../GeneralComponents";
import PictureAsPdfIcon from "@material-ui/icons/PictureAsPdf";
import { IconButton, Modal } from "@material-ui/core";
import CloseIcon from "mdi-react/CloseIcon";
import ActualizarVersion from "./ActualizarVersion";
import { makeStyles } from "@material-ui/core/styles";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFileSignature,
  faSignature,
} from "@fortawesome/free-solid-svg-icons";
import { DobleAutenticacion } from "./DobleAutenticacion";

const useStyles = makeStyles({
  centeredCell: {
    display: "flex",
    alignItems: "start", // Vertical centering
    whiteSpace: "pre-wrap", // Tries to keep the text on a single line
    overflow: "hidden", // Hides overflow if it's on one line
    textOverflow: "ellipsis", // Adds '...' if the text is truncated
    lineHeight: "normal", // Ensure standard line height
  },
});

export function DocumentsManagement() {
  const classes = useStyles();
  const [documentoSeleccionado, setDocumentoSeleccionado] =
    React.useState(null);
  const [documentos, setDocumentos] = React.useState([]);
  const [loadDependencias, setLoadDependencias] = React.useState([]);
  const [listTypesDocumentales, setListTypesDocumentales] = React.useState([]);
  const [showPdf, setShowPdf] = React.useState(false);
  const [formData, setFormData] = React.useState({
    codigo: "",
    fecha_creacion: moment(),
    confidencial: true,
    id_gd_dependencia: "",
  });
  const [openModalVersion, setopenModalVersion] = React.useState(null);
  const [page, setPage] = React.useState(0);
  const [pageSize, setPageSize] = React.useState(5);
  const [rowCount, setRowCount] = React.useState(0);
  const [listUsersCopiaDep, setListUsersCopiaDep] = React.useState([]);
  const dependenciaCopia = formData.copia_dependencia;
  const [openModalFirmaElectronica, setOpenModalFirmaElectronica] =
    React.useState(null);

  useEffect(() => {
    loadDocumentos();
  }, [page, pageSize]);

  useEffect(() => {
    if (dependenciaCopia) {
      loadUsersDep();
    }
  }, [dependenciaCopia]);

  const { showModalAlert } = useModalAlert();

  useEffect(() => {
    listDependencias();
  }, []);

  useEffect(() => {
    if (dependenciaCopia) {
      loadUsersDep();
    }
  }, [dependenciaCopia]);

  useEffect(() => {
    if (!!formData.id_gd_dependencia) {
      loadTipoDocumentales(formData.id_gd_dependencia);
    }
  }, [formData]);

  const sendCorreo = async (id_documento) => {    
    try {
      let dataSend = {
        id_gd_documentos: id_documento,
      };
      await fetch(process.env.REACT_APP_PUBLIC_URL + "doble-autenticacion/generaOTP", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
        body: JSON.stringify(dataSend),
      });
    } catch (error) {
      console.error("error....", error);
      
      showModalAlert("danger", "Error enviando el correo");
    }
  };

  const handleCloseModalFirmaElec = () => {
    setOpenModalFirmaElectronica(false);
  };

  const handlePageChange = (pageNumber) => {
    setPage(pageNumber);
  };

  const handlePageSizeChange = (pageSize) => {
    setPageSize(pageSize);
  };

  const handleOpenModal = (row) => {
    setopenModalVersion(true);
    setDocumentoSeleccionado(row);
  };

  const handleOpenFirmaElec = (row) => {
    setOpenModalFirmaElectronica(true)
    setDocumentoSeleccionado(row);
  };

  const handleCloseModal = () => {
    setopenModalVersion(false);
  };

  const columns = [
    {
      field: "fecha_creacion",
      headerName: "FECHA CREACIÓN",
      type: "date",
      flex: 0.6,
      disableColumnMenu: true,
      sortable: false,
      valueFormatter: (params) =>
        params.value ? moment(params.value).format("DD/MM/YYYY") : "",
    },
    {
      field: "version",
      headerName: "VERSIÓN",
      flex: 0.5,
      disableColumnMenu: true,
      sortable: false,
    },
    {
      field: "codigo",
      headerName: "CÓDIGO",
      flex: 0.7,
      disableColumnMenu: true,
      sortable: false,
    },
    {
      field: "nombre_documento",
      headerName: "NOMBRE DEL DOCUMENTO",
      type: "string",
      flex: 1.5,
      disableColumnMenu: true,
      sortable: false,
      renderCell: (params) => (
        <div className={classes.centeredCell} style={{ width: "100%" }}>
          {params.value}
        </div>
      ),
    },
    /*     {
      field: "sistema_gestion",
      headerName: "SISTEMA DE GESTIÓN",
      type: "string",
      flex: 1.1,
      disableColumnMenu: true,
      sortable: false,
    }, */
    {
      field: "nombre_dependencia",
      headerName: "DEPENDENCIA/PRODUCTORA",
      type: "string",
      flex: 1.3,
      disableColumnMenu: true,
      sortable: false,
    },
    {
      field: "estado",
      headerName: "ESTADO",
      type: "string",
      flex: 0.6,
      disableColumnMenu: true,
      sortable: false,
      valueGetter: (params) =>
        params.value != null
          ? params.value === "A"
            ? "Activa"
            : "Inactiva"
          : "No aplica",
    },
  ];

  const newModalField = [
    {
      name: "fecha_creacion",
      label: "Fecha de Creación",
      type: "date",
    },
    { name: "version", label: "Versión", type: "text" },
    { name: "codigo", label: "Código", type: "text" },
    { name: "nombre_documento", label: "Nombre del documento", type: "text" },
    {
      name: "sistema_gestion",
      label: "Sistema de Gestión",
      type: "select",
      options: [
        { value: "calidad", label: "Calidad" },
        { value: "seguridad", label: "Seguridad" },
      ],
    },
    {
      name: "id_gd_dependencia",
      label: "Dependencia/Productora",
      type: "select",
      options: loadDependencias,
    },
    {
      name: "id_gd_tipo_documental",
      label: "Tipo documentales",
      type: "select",
      disable: true,
      options: listTypesDocumentales,
    },
    { name: "ubicacion_fisica", label: "Ubicación Física", type: "text" },
    {
      name: "copia_dependencia",
      label: "Copia a la Dependencia",
      type: "optionalField",
      options: loadDependencias,
    },
    {
      name: "copia_usuario",
      label: "Copia al Usuario",
      type: "optionalField",
      options: listUsersCopiaDep,
    },
    {
      name: "nombre_archivo_origen",
      label: "Archivo Adjunto",
      type: "file",
      accept: ".pdf",
    },
    {
      name: "confidencial",
      label: "¿Es Confidencial?",
      type: "radio",
      defaultValue: true, // Opcional: Define un valor predeterminado al abrir
    },
    /*  {
      name: "copia_usuario",
      label: "Copia al Usuario",
      type: "optionalField",
      options: listUsersCopiaDep,
    }, */

    /* {
      name: "documento_anexo",
      label: "Archivo anexo",
      type: "file",
      accept: ".xlsx, .doc",
    } */
  ];

  const requiredFields = [
    "version",
    "codigo",
    "nombre_documento",
    "sistema_gestion",
    "id_gd_dependencia",
    "id_gd_tipo_documental",
    "ubicacion_fisica",
    "nombre_archivo_origen",
  ];

  async function handleSaveDocument(formData) {
    try {
      const token = sessionStorage.getItem("token");
      const payload = new FormData();

      const copia_dependencia_obj = (formData.copia_dependencia || []).reduce(
        (acc, id) => {
          const found = loadDependencias.find((item) => item.value === id);
          if (found) acc[id] = found.label;
          return acc;
        },
        {},
      );

      // 2. Procesar copia_usuario (Convertir array de IDs a Objeto {id: label})
      const copia_usuario_obj = (formData.copia_usuario || []).reduce(
        (acc, id) => {
          const found = listUsersCopiaDep.find((item) => item.value === id);
          if (found) acc[id] = found.label;
          return acc;
        },
        {},
      );

      const datosParaEnviar = {
        ...formData,
        copia_dependencia: copia_dependencia_obj,
        copia_usuario: copia_usuario_obj,
      };

      Object.keys(datosParaEnviar || {}).forEach((key) => {
        const value = datosParaEnviar[key];

        if (value === undefined || value === null) return;

        // Manejo de fechas con moment
        if (moment.isMoment && moment.isMoment(value)) {
          payload.append(key, value.format("YYYY-MM-DD"));
        } else if (value instanceof File) {
          payload.append(key, value);
        } else if (value instanceof FileList) {
          if (value.length) payload.append(key, value[0]); // tomar primer archivo
        } else {
          // IMPORTANTE: Evita enviar "copia_dependencia" o "copia_usuario"
          // desde el formData original si ya los procesaste arriba.
          if (key !== "copia_dependencia" && key !== "copia_usuario") {
            payload.append(
              key,
              typeof value === "object" ? JSON.stringify(value) : value,
            );
          }
        }
      });

      const updateResponse = await fetch(
        process.env.REACT_APP_PUBLIC_URL + "documento/create",
        {
          method: "POST",
          headers: {
            authorization: "Bearer " + token, // NO incluir Content-Type
          },
          body: payload,
        },
      );

      const result = await updateResponse.json();
      loadDocumentos();
      showModalAlert("success", "Se creó correctamente el documento");
    } catch (error) {
      showModalAlert("danger", "Error al crear el documento");
      throw error;
    }
  }

  const onActivate = async (row) => {
    try {
      let usuario = JSON.parse(sessionStorage.getItem("usuario"));
      let dataSend = {
        id_gd_documentos: row.id_gd_documentos,
        id_usuario: usuario.id_usuario,
      };
      await fetch(process.env.REACT_APP_PUBLIC_URL + "documento/activar", {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
        body: JSON.stringify(dataSend),
      });
      loadDocumentos();
      showModalAlert("success", "Se activo correctamente el documento");
    } catch (error) {
      showModalAlert("danger", "Error al activar el documento");
    }
  };
  const consultarRegistro = async () => {
    const response = await fetch(
      process.env.REACT_APP_PUBLIC_URL + "documento/consult",
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
      },
    );
  };
  const onInactivate = async (row) => {
    try {
      let usuario = JSON.parse(sessionStorage.getItem("usuario"));
      let dataSend = {
        id_gd_documentos: row.id_gd_documentos,
        id_usuario: usuario.id_usuario,
      };
      await fetch(process.env.REACT_APP_PUBLIC_URL + "documento/inactivar", {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
        body: JSON.stringify(dataSend),
      });
      loadDocumentos();
      showModalAlert("success", "Se inactivo correctamente el documento");
    } catch (error) {
      showModalAlert("danger", "Error al inactivar el documento");
    }
  };

  const actionsList = [
    {
      title: "Gestión de documentos",
      ariaLabel: "history-changes",
      icon: <AssignmentIcon />,
      onClick: (row) => {
        history.push({
          pathname:
            process.env.PUBLIC_URL + "/document-management/version_history",
          state: {
            documento: row,
          },
        });
      },
      //show: (row) => !!row, // Puedes controlar visibilidad
    },
    {
      title: "Ver documento",
      ariaLabel: "view-document",
      icon: <PictureAsPdfIcon />,
      onClick: (row) => {
        setDocumentoSeleccionado(row);
        setShowPdf(true);
      },
    },
    {
      title: "Firma electrónica",
      ariaLabel: "signature-document",
      icon: <FontAwesomeIcon icon={faFileSignature} />,
      onClick: (row) => {
        handleOpenFirmaElec(row);
        sendCorreo(row.id_gd_documentos)
      },
      //show: (row) => !!row, // Puedes controlar visibilidad
    },
    {
      title: "Actualizar documento",
      ariaLabel: "update-document",
      icon: <CloudUploadIcon />,
      onClick: (row) => {
        handleOpenModal(row);
      },
      //show: (row) => !!row, // Puedes controlar visibilidad
    },
    {
      title: "Firma digital",
      ariaLabel: "signature-document",
      icon: <FontAwesomeIcon icon={faSignature} />,
      onClick: (row) => {
        //handleOpenModal(row);
      },
      //show: (row) => !!row, // Puedes controlar visibilidad
    },
  ];

  const listDependencias = async () => {
    await fetch(
      process.env.REACT_APP_PUBLIC_URL + "dependencia/listar?estado=A",
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
      },
    )
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        const listaDependencias = data.results.map((unidad) => {
          return {
            value: unidad.id_gd_dependencia,
            label: unidad.descripcion,
          };
        });
        setLoadDependencias(listaDependencias);
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  const loadTipoDocumentales = async (id_gd_dependencia) => {
    await fetch(
      process.env.REACT_APP_PUBLIC_URL +
        `dependencia-trd/listar?id_gd_dependencia=${id_gd_dependencia}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
      },
    )
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        const listatipoDocumental = data.map((tipoDocumental) => {
          return {
            value: tipoDocumental.id_gd_tipo_documental,
            label: tipoDocumental.descripcion_tipo_documental,
          };
        });
        setListTypesDocumentales(listatipoDocumental);
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  const loadDocumentos = async () => {
    await fetch(
      process.env.REACT_APP_PUBLIC_URL +
        `documento/listar?page=${page + 1}&page_size=${pageSize}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
      },
    )
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        setRowCount(data.count);
        setDocumentos(data.results);
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  const loadUsersDep = async () => {
    const data = { id_gd_dependencia_copia: dependenciaCopia };
    await fetch(process.env.REACT_APP_PUBLIC_URL + "usuario/listarCopiaDep", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        authorization: "Bearer " + sessionStorage.getItem("token"),
      },
      body: JSON.stringify(data),
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        const listaUser = data.map((user) => ({
          value: user.id_usuario,
          label: user.nombre_usuario,
        }));
        setListUsersCopiaDep(listaUser);
      })
      .catch((error) => {
        console.error("Error:", error);
        setListUsersCopiaDep([]);
      });
  };

  return (
    <>
      <GeneralTable
        title=""
        titleAlert="Documento"
        buttonText="Crear Documento"
        columns={columns}
        rows={documentos}
        modalFields={newModalField}
        initialFormData={{
          codigo: "",
          descripcion: "",
          fecha_creacion: moment(),
        }}
        onSaveModal={handleSaveDocument}
        actionsList={actionsList}
        onActivate={onActivate}
        onInactivate={onInactivate}
        enableUpdate={false}
        enableDocumentarytype={false}
        enableView
        formData={formData}
        setFormData={setFormData}
        enableActivate
        loadList={loadDocumentos}
        requiredFields={requiredFields}
        rowCount={rowCount}
        pageSize={pageSize}
        page={page}
        handlePageChange={handlePageChange}
        handlePageSizeChange={handlePageSizeChange}
        isModalDocument={true}
        consultarRegistro={consultarRegistro}
      />
      {showPdf ? (
        <Modal
          open={showPdf}
          aria-labelledby="simple-modal-title"
          aria-describedby="simple-modal-description"
          style={{ zIndex: 1000 }}
        >
          <div
            className="paperAppointment-flex"
            style={{ width: "100%", margin: 10 }}
          >
            <IconButton
              style={{ float: "right" }}
              onClick={() => {
                setShowPdf(false);
              }}
            >
              <CloseIcon />
            </IconButton>
            <iframe
              id="pdfV"
              width="1000"
              height="700"
              src={
                process.env.REACT_APP_PUBLIC_URL +
                "documento/ver/" +
                documentoSeleccionado.id_gd_documentos +
                "/" +
                sessionStorage.getItem("token")
              }
            ></iframe>
          </div>
        </Modal>
      ) : null}
      {openModalVersion && (
        <ActualizarVersion
          openModal={openModalVersion}
          handleCloseModal={handleCloseModal}
          documentoSeleccionado={documentoSeleccionado}
          loadDocumentos={loadDocumentos}
        />
      )}
      {openModalFirmaElectronica && (
        <DobleAutenticacion
          openModal={openModalFirmaElectronica}
          handleCloseModal={handleCloseModalFirmaElec}
          documentoSeleccionado={documentoSeleccionado}
          loadDocumentos={loadDocumentos}
          
        />
      )}
    </>
  );
}
